import WalledContent from 'components/Common/WalledContent'
import OfferTileLoggedInButtons from 'components/OfferList/OfferListTiles/Support/OfferTileLoggedInButtons'
import BedbankOfferPriceDetails from 'components/OfferList/OfferCards/BedbankOfferPriceDetails'
import {
  PriceContentInner,
  PriceDetailsButton,
  PriceDetailsContainer,
  PriceDetailsContent,
  ViewOfferButton,
} from './LesaNlsOfferPriceDetails.shared'

interface Props {
  compact?: boolean
  offer: App.BedbankOffer | App.BedbankOfferSummary | App.BedbankOfferWithRate
  selectedDatesAndRoomsFilter?: App.OfferListFilters
}

export function LesaNlsBedbankOfferPriceDetails({ compact = false, offer, selectedDatesAndRoomsFilter }: Props) {
  const wall = (
    <OfferTileLoggedInButtons
      discountLabelAlign="end"
      align="right"
      fullWidth={false}
    />
  )

  return (
    <WalledContent enforced={offer.walledGarden} hidePricing={offer.hidePricing} wall={wall}>
      <PriceDetailsContainer $compact={compact}>
        <PriceDetailsContent $compact={compact}>
          <PriceContentInner $compact={compact}>
            <BedbankOfferPriceDetails offer={offer} selectedDatesAndRoomsFilter={selectedDatesAndRoomsFilter} />
          </PriceContentInner>
        </PriceDetailsContent>
        <PriceDetailsButton $compact={compact}>
          <ViewOfferButton compact={compact} />
        </PriceDetailsButton>
      </PriceDetailsContainer>
    </WalledContent>
  )
}
